import React from "react";
import { connect } from "react-redux";

import EducationDetail from "./EducationDetail";
import getMyUserEducationProfile from "../../../../../_selectors/userSelectors/getMyUserEducationProfile";
const Education = ({ userProfile, update, showToast }) => {
  return (
    <EducationDetail
      userProfile={userProfile}
      update={update}
      toast={showToast}
      showEdit={true}
    />
  );
};
const mapStateToProps = (state, ownProps) => ({
  userProfile: getMyUserEducationProfile(state)
});

export default connect(mapStateToProps)(Education);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/Education/index.js